export const initialState = {
    userInfo:{},
    userAccessToken:'',
    isSignIn:false
};

const AuthReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_USER_INFO':{
            return  {
                ...state,
                userInfo:action.value
            }
        }
        case 'SET_USER_TOKEN':{
            return  {
                ...state,
                userAccessToken:action.value
            }
        }
        case 'SET_USER_SIGNIN':{
            return  {
                ...state,
                isSignIn:action.value
            }
        }
        default:
            return state;
    }

};

export default AuthReducer;
